// extracted by mini-css-extract-plugin
module.exports = {"root":"BookingTimeInfo_root__2rokB","bookingInfo":"BookingTimeInfo_bookingInfo__2pKEk","dateSection":"BookingTimeInfo_dateSection__twEih"};